import { render, staticRenderFns } from "./SelectMessageType.vue?vue&type=template&id=30e29f82&scoped=true&"
import script from "./SelectMessageType.vue?vue&type=script&lang=js&"
export * from "./SelectMessageType.vue?vue&type=script&lang=js&"
import style0 from "./SelectMessageType.vue?vue&type=style&index=0&id=30e29f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e29f82",
  null
  
)

export default component.exports